"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./i18next/i18n"), exports);
(0, tslib_1.__exportStar)(require("./i18next/useLocation"), exports);
